function initFooterFocus() {
  const footerLogo = document.querySelector('.footer-logo');
  
  if (!footerLogo) return;

  const focus = footerLogo.querySelector('.focus');
  
  if (!focus) return;

  footerLogo.addEventListener('mousemove', (e) => {
    const rect = footerLogo.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    focus.style.left = `${x}px`;
    focus.style.top = `${y}px`;
    focus.style.transform = 'translate(-50%, -50%)';
  });

  footerLogo.addEventListener('mouseenter', () => {
    focus.style.opacity = '1';
  });

  footerLogo.addEventListener('mouseleave', () => {
    focus.style.opacity = '0';
  });
}

export { initFooterFocus };
